import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getFundClassifications, saveBatchFundClassifications } from '../../api/fundClassifications';
import type { FundClassification } from '../../types/FundClassification';
import { t } from '../../i18n/t';

const columnDefs: ColDef<FundClassification>[] = [
  {
    field: 'fundClassificationId',
    headerName: t('fundClassifications.columns.fundClassificationId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<FundClassification>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'fundClassificationName', headerName: t('fundClassifications.columns.fundClassificationName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<FundClassification> => ({ fundClassificationId: 0, fundClassificationName: '' });

export function FundClassificationsPage() {
  return (
    <LopCrudPage<FundClassification>
      resourceCode="fundClassifications"
      titleKey="fundClassifications.pageTitle"
      idField="fundClassificationId"
      getRows={getFundClassifications}
      saveBatch={(added, modified, deletedIds) => saveBatchFundClassifications(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
